module.exports = __webpack_public_path__ + "img/VentoBlack.66ab6393.svg";